<template>
  <div>
    <avue-crud
      :option="option"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
    </avue-crud>

    <el-drawer
      title=""
      :visible.sync="viewShow"
      :direction="direction"
      append-to-body
      :before-close="handleClose"
      size="80%"
    >
      <ViewKnowledge v-if="viewShow" :data="currentRow" />
    </el-drawer>

    <el-dialog :visible.sync="adoptShow" width="80%" :before-close="handleClose" append-to-body>
      <AdoptForm
        v-if="adoptShow"
        :form="currentRow"
        :projectList="projectList"
        @close="closeAdoptForm"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getKnowledgeGroupFileRecommendPage, noAdopt } from '@/api/crmedical/knowledge/group';
import ViewKnowledge from './viewRecommend';
import AdoptForm from './adoptForm';
export default {
  components: { ViewKnowledge, AdoptForm },
  props: ['projectList'],

  data() {
    return {
      projectList: [],
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: false,
        searchMenuSpan: 6,
        border: true,
        index: true,
        addBtn: false,
        refreshBtn: false,
        columnBtn: false,
        searchIcon: false,
        viewBtn: true,
        editBtnText: '采用',
        delBtnText: '不采用',
        selection: false,
        column: [
          {
            label: '文件标题',
            prop: 'title',
          },
          {
            label: '文件类型',
            prop: 'extension',
          },
          {
            label: '文件说明',
            prop: 'content',
          },
          {
            label: '推荐医院',
            prop: 'projectName',
          },
          {
            label: '推荐人',
            prop: 'userName',
          },
          {
            label: '推荐原因',
            prop: 'description',
          },
          {
            label: '推荐日期',
            prop: 'createTime',
          },
        ],
      },
      data: [],
      viewShow: false,
      currentRow: null,
      adoptShow: false,
    };
  },
  created() {},
  methods: {
    beforeOpen(done, type) {
      console.log('type==>', type);
      console.log('done==>', done);
    },
    rowDel(row) {
      console.log('row==>', row);

      let fd = new FormData();
      fd.append('id', row.id);

      this.$confirm('是否不采用？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return noAdopt(fd);
        })
        .then((res) => {
          this.onload();
          this.$message.success(res.msg);
        })
        .catch((err) => {
          console.log('err==>', err);
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onload();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onload();
    },
    beforeOpen(done, type) {
      console.log('this.form==>', this.form);
      if (type == 'view') {
        this.currentRow = this.form;
        this.viewShow = true;
      }
      //采用
      if (type == 'edit') {
        this.form.menuId = '';
        this.currentRow = this.form;
        this.adoptShow = true;
      }
    },
    closeAdoptForm() {
      this.adoptShow = false;
      this.onload();
    },
    onload() {
      const params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
      };
      getKnowledgeGroupFileRecommendPage(params).then((res) => {
        this.page.total = res.data.total;
        this.data = res.data.records;
      });
    },
  },
  created() {
    this.onload();
  },
};
</script>